export default {"src":"/_next/static/media/msg.45a23b58.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};